import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SectionHead } from "./Reveal";
import { EASE } from "@/lib/site";

const SERVICES = [
  ["Scavi e movimento terra", "Scavi per fondazioni, sottoservizi, drenaggi e sistemazioni esterne con propri mezzi."],
  ["Demolizioni e rimozioni", "Smontaggi, demolizioni controllate e smaltimento a norma dei materiali di risulta."],
  ["Opere murarie e cartongesso", "Nuove distribuzioni degli spazi, controsoffitti, nicchie e velette su misura."],
  ["Impianti", "Impianti elettrici, idraulici e di climatizzazione, certificati e a norma."],
  ["Bagni e cucine", "Progettazione e realizzazione completa di bagni e cucine, dagli scarichi alle finiture."],
  ["Posa di pavimenti e rivestimenti", "Grandi lastre, marmo, gres e parquet posati con precisione millimetrica."],
  ["Finiture e tinteggiature", "Rasature, pitture decorative, boiserie e pulizia finale prima della consegna."],
];

export const Services = () => (
  <section id="servizi" data-testid="services-section" className="relative bg-[#0d0d0e] py-28 lg:py-40">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <SectionHead label="Servizi" title={<>Tutto il cantiere, <em className="italic text-[#e8c063]">in un'unica regia.</em></>} />
        </div>
        <p className="lg:col-span-4 lg:col-start-9 text-[#c9c3b7] leading-relaxed">
          Coordiniamo le nostre squadre in ogni lavorazione: tu non devi cercare, chiamare o coordinare nessun altro.
        </p>
      </div>
      <ul className="mt-20 border-t border-[#d4a73c]/20">
        {SERVICES.map(([t, d], i) => (
          <motion.li key={t} data-testid={`service-item-${i}`}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, delay: i * 0.06, ease: EASE }}
            className="group relative grid grid-cols-12 gap-4 items-baseline py-8 md:py-10 border-b border-[#d4a73c]/20 overflow-hidden">
            <span className="absolute inset-0 bg-[#d4a73c]/[0.06] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-700" />
            <span className="relative col-span-2 md:col-span-1 font-display italic text-xl text-[#d4a73c]">{String(i + 1).padStart(2, "0")}</span>
            <h3 className="relative col-span-10 md:col-span-5 font-display text-3xl md:text-4xl font-light text-[#f4f1ea] group-hover:translate-x-3 transition-transform duration-700">{t}</h3>
            <p className="relative col-span-10 col-start-3 md:col-span-5 md:col-start-auto text-sm md:text-base text-[#c9c3b7] leading-relaxed">{d}</p>
            <ArrowUpRight className="relative hidden md:block col-span-1 justify-self-end text-[#d4a73c] opacity-0 -translate-x-3 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform] duration-500" />
          </motion.li>
        ))}
      </ul>
    </div>
  </section>
);
